import { validatenull } from './validate'
import sha256 from 'crypto-js/sha256'
import Base64 from 'crypto-js/enc-base64'
import env from '@/config/env'
import { pickBy } from 'lodash-es'
import qs from 'qs'

/**
 * @description 文件名处理
 * @param response 响应头信息
 * @param customName 自定义文件名,优先级高于服务端传递的filename
 */
export const getExportFileName = (response, customName) => {
  if (customName) return customName
  const contentDisposition = response.headers['content-disposition']
  // regexr.com
  const pattern = /filename=([^;\n]*)/gi
  const result = contentDisposition && pattern.exec(contentDisposition)
  let filename = ''
  if (result && result.length) filename = result[1]
  return filename ? decodeURIComponent(String(filename).trim().replace(/"/g, '')) : ''
}

// 表单序列化
export const serialize = (data) => {
  const list = []
  Object.keys(data).forEach((ele) => {
    list.push(`${ele}=${data[ele]}`)
  })
  return list.join('&')
}
export const getObjType = (obj) => {
  var toString = Object.prototype.toString
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}
export const getViewDom = () => {
  return window.document.getElementById('avue-view').getElementsByClassName('el-scrollbar__wrap')[0]
}
/**
 * 对象深拷贝
 */
export const deepClone = (data) => {
  var type = getObjType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}
/**
 * 设置灰度模式
 */
export const toggleGrayMode = (status) => {
  if (status) {
    document.body.className = document.body.className + ' grayMode'
  } else {
    document.body.className = document.body.className.replace(' grayMode', '')
  }
}
/**
 * 设置主题
 */
export const setTheme = (name) => {
  document.body.className = name
}

/**
 * 加密处理
 */
export const encryption = (params) => {
  const { data = {}, type, param, key } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach((ele) => {
      result[ele] = Base64.stringify(result[ele])
    })
  } else if (type === 'Aes') {
    param.forEach((ele) => {
      result[ele] = sha256(result[ele], key)
    })
  }
  return result
}

/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen()
  } else {
    reqFullScreen()
  }
}
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback()
  }
  document.addEventListener('fullscreenchange', function () {
    listen()
  })
  document.addEventListener('mozfullscreenchange', function () {
    listen()
  })
  document.addEventListener('webkitfullscreenchange', function () {
    listen()
  })
  document.addEventListener('msfullscreenchange', function () {
    listen()
  })
}
/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  var isFullscreen =
    document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
  return isFullscreen
}

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen()
  }
}
/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen()
  }
}
/**
 * 递归寻找子类的父类
 */

export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length !== 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id === id) {
          return menu[i]
        } else {
          if (menu[i].children[j].children.length !== 0) {
            return findParent(menu[i].children[j].children, id)
          }
        }
      }
    }
  }
}
/**
 * 判断2个对象属性和值是否相等
 */

/**
 * 动态插入css
 */

export const loadStyle = (url) => {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
}

/**
 * 判断路由是否相等
 */
export const diff = (obj1, obj2) => {
  delete obj1.close
  var o1 = obj1 instanceof Object
  var o2 = obj2 instanceof Object
  if (!o1 || !o2) {
    /*  判断不是对象  */
    return obj1 === obj2
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false
    // Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
  }

  for (var attr in obj1) {
    var t1 = obj1[attr] instanceof Object
    var t2 = obj2[attr] instanceof Object
    if (t1 && t2) {
      return diff(obj1[attr], obj2[attr])
    } else if (obj1[attr] !== obj2[attr]) {
      return false
    }
  }
  return true
}
/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
  let result = ''
  if (validatenull(dic)) return value
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    let index = 0
    index = findArray(dic, value)
    if (index !== -1) {
      result = dic[index].label
    } else {
      result = value
    }
  } else if (value instanceof Array) {
    result = []
    let index = 0
    value.forEach((ele) => {
      index = findArray(dic, ele)
      if (index !== -1) {
        result.push(dic[index].label)
      } else {
        result.push(value)
      }
    })
    result = result.toString()
  }
  return result
}
/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value === value) {
      return i
    }
  }
  return -1
}
/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000)
    .toString()
    .substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}
/**
 * 打开小窗口
 */
export const openWindow = (url, title, w, h) => {
  // Fixes dual-screen position                            Most browsers       Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height

  const left = width / 2 - w / 2 + dualScreenLeft
  const top = height / 2 - h / 2 + dualScreenTop
  const newWindow = window.open(
    url,
    title,
    'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' +
      w +
      ', height=' +
      h +
      ', top=' +
      top +
      ', left=' +
      left
  )

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus()
  }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  }

  const childrenListMap = {}
  const nodeIds = {}
  const tree = []

  for (const d of data) {
    const parentId = d[config.parentId]
    if (childrenListMap[parentId] === null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (const d of data) {
    const parentId = d[config.parentId]
    if (nodeIds[parentId] === null) {
      tree.push(d)
    }
  }

  for (const t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }
  return tree
}

/**
 * 构造前端下拉树形数据
 * @param data
 * @returns {[]}
 */
export function handleSelectTree(data) {
  data.forEach(function (item) {
    delete item.children
  })
  const map = {}
  data.forEach(function (item) {
    map[item.id] = item
  })
  const val = []
  data.forEach(function (item) {
    const parent = map[item.parentId]
    if (parent) {
      ;(parent.children || (parent.children = [])).push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      val.push(item)
    }
  })
  return val
}

/**
 * 将数组中的parentId列表取出，倒序排列
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function idList(data, val, id = 'id', children = 'children') {
  const res = []
  idListFromTree(data, val, res, id)
  return res
}

/**
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
function idListFromTree(data, val, res = [], id = 'id', children = 'children') {
  for (let i = 0; i < data.length; i++) {
    const element = data[i]
    if (element[children]) {
      if (idListFromTree(element[children], val, res, id, children)) {
        res.push(element[id])
        return true
      }
    }
    if (element[id] === val) {
      res.push(element[id])
      return true
    }
  }
}

/**
 * @param { Promise } promise
 * @param { Object= } errorExt - Additional Information you can pass to the err object
 * @return { Promise }
 */
export function to(promise, errorExt) {
  return promise
    .then((data) => [null, data])
    .catch((err) => {
      if (errorExt) {
        Object.assign(err, errorExt)
      }

      return [err, undefined]
    })
}

export function copyText(content) {
  // content为要复制的内容
  // 创建元素用于复制
  const ele = document.createElement('input')
  // 设置元素内容
  ele.setAttribute('value', content)
  // 将元素插入页面进行调用
  document.body.appendChild(ele)
  // 复制内容
  ele.select()
  // 将内容复制到剪贴板
  document.execCommand('copy')
  // 删除创建元素
  document.body.removeChild(ele)
}

// 生成随机id
export const uuidv5 = () => {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('')
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    /// FileReader类就是专门用来读文件的
    const reader = new FileReader()
    // 开始读文件
    // readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
    reader.readAsDataURL(file)
    // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
    reader.onload = () => resolve(reader.result)
    // 失败返回失败的信息
    reader.onerror = (error) => reject(error)
  })
}
/* 压缩base64图片 */
export const compressImage = (base64, quality = 0.9) => {
  const end = base64.indexOf(';', 5)
  const imageType = base64.substring(5, end)
  // 压缩系数0-1之间
  return new Promise((resolve) => {
    var newImage = new Image()
    newImage.src = base64
    newImage.setAttribute('crossOrigin', 'Anonymous') // url为外域时需要
    newImage.onload = function () {
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      const imageWidth = newImage.width
      const imageHeight = newImage.height
      canvas.width = imageWidth // 设置绘图的宽度
      canvas.height = imageHeight // 设置绘图的高度
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
      var base64 = canvas.toDataURL(imageType, quality) // 压缩语句
      // 如想确保图片压缩到自己想要的尺寸,如要求在5-10kb之间，请加以下语句，quality初始值根据情况自定
      // console.log(base64.length + "循环1压缩" + (base64.length / 1024 > 512))

      /* while (base64.length > targetSize) {
        quality -= 0.05
        // console.log(base64.length + "循环压缩" + quality)
        base64 = canvas.toDataURL('image/jpeg', quality)
      } */
      resolve(base64) // 必须通过回调函数返回，否则无法及时拿到该值
    }
  })
}
export function base64ToFile(base64, filename) {
  const arr = base64.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: mime
  })
}
export function getQueryString(name, str) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let res = null
  if (str) {
    res = str.match(reg)
  } else {
    res = window.location.search.substr(1).match(reg)
  }
  if (res && res.length > 1) {
    return res[2]
  }
  return ''
}

export function urlParams(str, name) {
  let href = str || location.search || location.hash
  if (!href || href.indexOf('?') < 0) {
    return ''
  }
  href = decodeURIComponent(href).substr(1)
  href = href.substr(href.lastIndexOf('?') + 1)
  if (!name) {
    const returns = {}
    const tmp = href.split('&')
    for (let i = 0; i < tmp.length; i++) {
      const now = tmp[i]
      const res = now.split('=')
      returns[res[0]] = res[1]
    }
    return returns
  }
  return getQueryString(name, href)
}

// 删除对象属性值为空的属性
export function removeEmptyProps(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] === '') {
      delete obj[prop]
    }
  }
  return obj
}

// 校验手机号码
export function isValidPhoneNumber(value) {
  value = value.replace(/\s*/g, '')
  // 手机号
  const regMobilePhone = /^1\d{10}$/
  // 座机号0871-xxxxxxx[x] 010xxxxxxx[x]
  const regCellPhone = /^0\d{2,3}-?\d{4}-?\d{3,4}/
  // 400/800
  const regPhone = /^[48]00-?\d{3}-?\d{4}$/
  return regMobilePhone.test(value) || regCellPhone.test(value) || regPhone.test(value)
}

export function isValidPlateNumber(value) {
  const reg =
    /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[ABCDEFGHJK])|([ABCDEFGHJK]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]\\d{3}\\d{1,3}[领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
  return reg.test(value)
}

// 接口导出文件
export function exportList(queryParam, url) {
  return new Promise((resolve) => {
    let exportUrl = env.importExcelUrl + env.ferryUrl + url
    const parma = pickBy({ ...queryParam })
    exportUrl = exportUrl + '?' + qs.stringify(parma)
    window.location.href = exportUrl
    resolve()
  })
}

// 将数字转换为千分位格式
export function addThousandsSeparatorWithDecimal(number) {
  if (!number) {
    return 0
  }
  // 将数字转换为字符串
  const numStr = String(number)

  // 分割整数和小数部分（如果有）
  const [integerPart, decimalPart] = numStr.split('.')

  // 添加千分位分隔符到整数部分
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // 格式化小数部分，最多保留两位小数
  const formattedDecimalPart = decimalPart ? decimalPart.slice(0, 2) : '00'

  // 构建格式化后的数字
  const formattedNumber = decimalPart
    ? `${formattedIntegerPart}.${formattedDecimalPart}`
    : formattedIntegerPart

  return formattedNumber
}

/**
 * 下载图片
 * @param {*} downloadUrl 图片路径
 * @param {*} sourceName 图片名   123.jpg
 */
export function downloadImgUseALabel(downloadUrl, sourceName) {
  const aLink = document.createElement('a')
  aLink.style.display = 'none'
  aLink.href = downloadUrl
  aLink.download = sourceName
  document.body.appendChild(aLink)
  aLink.click()
  document.body.removeChild(aLink)
}

/**
 * 下载zip包
 * @param {*} data 文件流数据
 * @param {*} name 文件名
 */
export function downloadZipUseALabel(data, name) {
  var blob = new Blob([data], { type: 'application/zip' })
  var downloadElement = document.createElement('a')
  var href = window.URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href
  downloadElement.download = name // 定义文件名
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}
// 过滤文件地址，返回原始文件名称
export const formatFileName = (name, pickType = false) => {
  if (!name) {
    return pickType ? { name: '', fileType: '' } : ''
  }
  const regSplit = /(?:\d{13}_?)?([^/?#]+\.[a-zA-A0-9]+)(?=[?#])/gi
  const nameArr = name.split(regSplit)
  const longName = nameArr[1] || ''
  if (!longName) {
    return pickType ? { name: '', fileType: '' } : ''
  }
  const typeReg = /\.([a-zA-Z0-9]+)$/
  const fileType = longName.match(typeReg)
  if (pickType) {
    return {
      name: longName,
      fileType: fileType[1]
    }
  }
  return longName || name
}

/**
 * 去除表情
 */
export function filterEmoji(prop, source) {
  const val = source[prop]
  if (!val) return ''

  // 表情符号正则
  const emojiRegex =
    /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu

  // 如果检测到表情符号
  if (emojiRegex.test(val)) {
    // 移除表情符号
    const filtered = val.replace(emojiRegex, '')

    // 如果内容变化了，显示提示
    if (filtered !== val) {
      // this.$message.warning('导航名称不能包含表情符号，已自动移除');

      // 更新模型值 (注意这里直接修改了表单的值)
      source[prop] = filtered
    }

    return filtered
  }

  return val
}
